"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const actions_1 = require("../../actions");
const reducers_1 = require("../../reducers");
const CampaignsListShowMorePopover = ({ activePopover, updateActivePopover, campaign, duplicateCampaignName, duplicateCampaign, archiveCampaign, device, publishedCampaignStatus, pushToModal, archiveModalToggle, isArchiveModalOpen, }) => {
    const { id } = campaign;
    const currentPopover = `list-page-more-popover-${id}`;
    const parseCampaignId = parseInt(id, 10);
    const handleDuplicate = () => {
        duplicateCampaign(duplicateCampaignName, parseCampaignId);
        updateActivePopover('');
    };
    const handleArchive = () => {
        archiveCampaign(parseCampaignId);
        archiveModalToggle(false);
        updateActivePopover('');
    };
    const pushToSettings = () => {
        pushToModal('settings');
        updateActivePopover('');
    };
    const showArchiveModal = () => {
        archiveModalToggle(true);
    };
    return (React.createElement(src_1.PopoverContainer, { id: "list-page-more-icon", popoverProps: {
            placement: 'left',
        }, onClick: () => activePopover === currentPopover ? updateActivePopover('') : updateActivePopover(currentPopover), targetParent: "root", showPopover: activePopover === currentPopover },
        React.createElement(src_1.MoreIcon, { fill: src_1.charcoal, height: "20", width: "20", viewBox: "0 0 24 24", key: "list-page-more-icon-1" }),
        React.createElement("div", { style: {
                width: 280,
            }, key: "list-page-more-icon-2" },
            React.createElement(src_1.SelectableList, { device: device },
                ['ACTIVE', 'EXPIRED', 'SENT'].includes(publishedCampaignStatus) ? (React.createElement("div", { onClick: pushToSettings, style: {
                        display: 'flex',
                        alignItems: 'center',
                        height: 55,
                    }, key: "settings-icon-list-view-popover" },
                    React.createElement("div", { style: {
                            marginRight: 8,
                        } }, src_1.GearIcon({
                        width: '20',
                        height: '20',
                        viewBox: '0 0 24 24',
                        fill: src_1.steel,
                    })),
                    React.createElement(src_1.Text, { text: "Settings", size: "medium" }))) : null,
                React.createElement("div", { onClick: handleDuplicate, style: {
                        display: 'flex',
                        alignItems: 'center',
                        height: 55,
                    }, key: "duplicate-icon-list-view-popover" },
                    React.createElement("div", { style: {
                            marginRight: 8,
                        } }, src_1.DuplicateIcon({
                        width: '20',
                        height: '20',
                        viewBox: '0 0 24 24',
                        fill: src_1.steel,
                    })),
                    React.createElement(src_1.Text, { text: "Duplicate", size: "medium" })),
                React.createElement("div", { onClick: showArchiveModal, style: {
                        display: 'flex',
                        alignItems: 'center',
                        height: 56,
                    }, key: "archive-icon-list-view-popover" },
                    React.createElement("div", { style: {
                            marginRight: 8,
                        } }, src_1.ArchiveIcon({
                        width: '20',
                        height: '20',
                        viewBox: '0 0 24 24',
                        fill: src_1.steel,
                    })),
                    React.createElement(src_1.Text, { text: "Archive", size: "medium" }))),
            isArchiveModalOpen && (React.createElement(src_1.Dialog, { buttonPrimaryText: "Cancel", buttonSecondaryText: "Yes", primaryOnClick: () => archiveModalToggle(false), secondaryOnClick: () => handleArchive(), isOpen: isArchiveModalOpen, targetParent: "root", dialogText: `Are you sure you'd like to archive this campaign?`, overlayStyle: { zIndex: 1000 } })))));
};
const mapStateToProps = (state, ownProps) => {
    const { campaign } = ownProps;
    return {
        activePopover: reducers_1.getActivePopover(state),
        duplicateCampaignName: reducers_1.getDuplicateCampaignName(campaign),
        publishedCampaignStatus: reducers_1.getPublishedCampaignLifecycleStatus(state, campaign.id),
        isArchiveModalOpen: reducers_1.getIsArchiveModalOpen(state),
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        updateActivePopover: (activePopover) => dispatch(actions_1.updateActivePopover(activePopover)),
        duplicateCampaign: (name, campaignId) => {
            dispatch(actions_1.duplicateListViewCampaign(name, campaignId));
        },
        archiveCampaign: (campaignId) => {
            dispatch(actions_1.archiveListViewCampaign(campaignId));
        },
        archiveModalToggle: (display) => {
            dispatch(actions_1.archiveModalOpen(display));
        },
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(CampaignsListShowMorePopover);
